// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer----footer-module---footer---3YcZG","footerBranding":"src-components-Footer----footer-module---footerBranding---kRXsJ","header":"src-components-Footer----footer-module---header---oSO5u","li":"src-components-Footer----footer-module---li---10rMW","registerLink":"src-components-Footer----footer-module---registerLink---1BK7_","meta":"src-components-Footer----footer-module---meta---1GZCG","metaText":"src-components-Footer----footer-module---metaText---cVh5o","links":"src-components-Footer----footer-module---links---EXm1s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.module.scss
// module id = 315
// module chunks = 168707334958949